import { render, staticRenderFns } from "./BenefitsRegister.vue?vue&type=template&id=4c41397c"
import script from "./BenefitsRegister.vue?vue&type=script&lang=js"
export * from "./BenefitsRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports